<template>
  <div id="SupplierDetail">
    <van-nav-bar
      :title="pageTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-cell>
      <div class="box">
        <van-image width="100" height="100" :src="supplierInfo.shopLogo">
          <template v-slot:error>
            <van-image
              width="100"
              height="100"
              :src="require('@/assets/images/supplier_default_logo.jpeg')"
          /></template>
        </van-image>
        <div style="margin-left: 20px; width: 100%">
          <p style="font-size: 18px">{{ supplierInfo.shopName }}</p>
          <p style="font-size: 12px" class="description">
            {{
              supplierInfo.description ? supplierInfo.description : '暂无介绍'
            }}
          </p>
          <p class="footer">
            <van-tag type="primary"
              style="padding: 5px;"><van-icon name="phone-o" /><a
                style="color: #ffffff"
                href="tel:{{ supplierInfo.mobile }}"
                >{{ supplierInfo.mobile }}</a
              ></van-tag
            >
          </p>
        </div>
      </div>
    </van-cell>
    <van-tabs v-model:active="tabActive">
      <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name">
        <GoodsLists
          :shopId="$route.params.id"
          :categoryId="item.id"
        ></GoodsLists>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'SupplierDetail',
  data() {
    return {
      pageTitle: '',
      tabs: [],
      categoryId: 0,
      supplierInfo: {},
      tabActive: 0,
    }
  },
  created() {
    this.pageTitle = this.$route.meta.title
    this.$axios
      .post(
        this.$axios.defaults.baseURL + '/market/supplier/detail',
        {
          shopId: this.$route.params.id,
        },
        {}
      )
      .then((response) => {
        this.supplierInfo = response.data.data
      })
      .catch((error) => {
        if (error.response) {
          this.$toast(error.response.data.message)
        } else if (error.request) {
          if (error.request.status == 0) {
            this.$toast('服务器溜号了，赶快召唤神龙大侠阿宝～')
          }
        } else {
          console.log('Error', error.message)
        }
      })
    this.$axios
      .post(
        this.$axios.defaults.baseURL + '/market/goods/category',
        {
          shopId: this.$route.params.id,
        },
        {}
      )
      .then((response) => {
        this.tabs = response.data.data.items
      })
      .catch((error) => {
        if (error.response) {
          this.$toast(error.response.data.message)
        } else if (error.request) {
          if (error.request.status == 0) {
            this.$toast('服务器溜号了，赶快召唤神龙大侠阿宝～')
          }
        } else {
          console.log('Error', error.message)
        }
      })
  },
  methods: {
    onClickLeft() {
      this.$router.replace('/')
    },
  },
}
</script>

<style lang="less" scoped>
.box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.description {
  color: #969799;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  height: 4em;
}

.footer {
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}
</style>
